import uuid from 'uuid-random';
import { send } from 'server';

export const getPaymentMethodList = data => send({
    limits: true,
    cancreatenewaccount: true,
    returnaccountfields: true,
    ...data,
    ID: 33001,
    responses: [33002, 33003],
    description: 'Get payment method list'
});

export const getPaymentMethodAccounts = data => send({
    hideAccountsWithoutInfo: true,
    ...data,
    ID: 33011,
    responses: [33012, 33013],
    description: 'Get payment method accounts'
});

export const doDeposit = data => send({
    ...data,
    ID: 33016,
    uuid: uuid(),
    description: 'Deposit',
    responses: [33015, 33014, 33029]
});

export const doWithdraw = data => send({
    ...data,
    ID: 33017,
    description: 'Withdraw',
    responses: [33057, 33018, 33019]
});

export const methodNotification = data => send({
    ...data,
    ID: 35720,
    description: '3D Secure v2 Method Notification',
    responses: [35721, 35722]
});

export const getTransactionPlayerMsg = data => send({
    ...data,
    ID: 35640,
    description: 'Get Transaction Player Message',
    responses: [35641, 35645]
});
